
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  id: '',
  firstName: '',
  lastName: '',
  urn:'',
  age:'',
  timeZone:'PST',
  language: 'English',
  groups: [],
  email: '',
  carePrograms: [],
  emergencyContact: {},
  healthInfo: {},
  address: {},
  preferences: {},
  phone: "",
  countryCode: '',
  mrn: "",
  ssn: "",
  canHaveAppointment: false,
  canManageAvailability: false,
  profilePictureURL: null,
  orgHierarchy: [],
  role: {},
  gender: '',
  fullName: '',
  notes: [],
  appointments: [],
  reports: [],
  careTeam: [],
  questionnaireIds: [],
  questionnaireResponses: [],
  taskNonCriticalReportId:'',
  taskEnrollmentId: '',
  alertTypeOpen: '',
  patientNotifications: [],
  tasksByPatient: [],
  pcp: {
    accountId: 0,
    fullName: ""
  },
  userSettingsForPatient: {
    sendSMS: false,
    alertAuthorized: false,
    pcp: false,
    alertSilenced: false
  },
  alerts: {
    active: {
      all: [],
      clinical: [],
      technical: [],
      operational: []
    },
    history: [],
    silenced: []
  },
  taskAlertId: '',
  lastCalibrationDate: ''
  
};

const patientSlice = createSlice({
  name: 'patient',
  initialState,
  reducers: {
    updatePatientInfo: (state, action) => {
      const id = action.payload;
      state.id = id;
    },
    setPatientPrograms: (state, action) => {
      state.carePrograms = action.payload;
    },
    setPatientOrgHierarchy: (state, action) => {
      state.orgHierarchy = action.payload;
    },
    setPatientDetails: (state, action) => {
      const { emergencyContact, healthInfo, address, preferences, phone, countryCode, groups, mrn, ssn, role, firstName, lastName, email, canHaveAppointment, canManageAvailability, profilePictureURL, lastCalibrationDate} = action.payload;
      return {
        ...state,
        groups: groups,
        emergencyContact: emergencyContact || {},
        healthInfo: healthInfo || {},
        address: address,
        preferences: preferences,
        phone: phone,
        countryCode: countryCode,
        mrn: mrn || "",
        ssn: ssn || "",
        role: role,
        firstName: firstName,
        lastName: lastName,
        email: email,
        fullName:`${firstName} ${lastName}`,
        canManageAvailability: canManageAvailability,
        canHaveAppointment: canHaveAppointment,
        profilePictureURL: profilePictureURL  || null,
        lastCalibrationDate: lastCalibrationDate || ''

      }
    },
    setFormField: (state, action) => {
      const { key, value } = action.payload;
      state[key] = value;
      if (key === "careTeam") {
        for (const staff of value) {
          if (staff.pcp) {
            let pcpInfo = {
              accountId: staff.id,
              fullName: `${staff.firstName} ${staff.lastName}`
            }
            state['pcp'] = pcpInfo;
            break;
          }
        }
      }
    },
    setAlerts: (state, action) => {
      const values = action.payload;
      // Filter out Bluetooth alerts before processing
      const filteredValues = values.filter((item) => 
        !item.alert_name?.includes('Bluetooth Error')
      );
      let activeAlerts = filteredValues.filter((item)=>item.alert_status === "active");

      let info = {
        active: {
          all: activeAlerts,
          clinical: activeAlerts.filter((item)=> item.alert_category === "clinical"),
          operational: activeAlerts.filter((item)=> item.alert_category === "operational"),
          technical: activeAlerts.filter((item)=> item.alert_category === "technical")
        },
        history: filteredValues.filter((item)=>item.alert_status === "resolved"),
        silenced: filteredValues.filter((item)=>item.alert_status === "silenced")
      }
      state['alerts'] = info;
    },
    setTaskNonCriticalReportId: (state, action) => {
      state.taskNonCriticalReportId = action.payload;
    },
    setTaskEnrollmentId: (state, action) => {
      state.taskEnrollmentId = action.payload;
    },
    resetPatientState: (state) => {
      Object.assign(state, initialState);
    },
  },
});

export const { updatePatientInfo, resetPatientState, setPatientPrograms, setPatientDetails, setFormField, setPatientOrgHierarchy,setTaskNonCriticalReportId, setTaskEnrollmentId, setAlerts } = patientSlice.actions;
export const selectPatientInfo = (state) => state.patient.info;

export default patientSlice.reducer;
